// import React, { useState, useEffect } from "react";
// import Sidebar from "../../Components/Sidebar";
// import TopNav from "../../Components/TopNav";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import moment from "moment";
// import NoRecordFound from "../../Components/NoRecordFound";

// import {
//   addStateServ,
//   bulkDeleteStateServ,
//   deleteStateServ,
//   getStateServ,
//   updateStateServ,
// } from "../../services/location.services";
// function StateList() {
//   const [list, setList] = useState([]);
//   const [statics, setStatics] = useState(null);
//   const [payload, setPayload] = useState({
//     searchKey: "",
//     status: "",
//     pageNo: 1,
//     pageCount: 10,
//     sortByField: "",
//   });
//   const [showSkelton, setShowSkelton] = useState(false);
//   const handleGetStateFunc = async () => {
//     if (list.length === 0) {
//       setShowSkelton(true);
//     }
//     try {
//       let response = await getStateServ(payload);
//       setList(response?.data?.data);
//       setStatics(response?.data?.documentCount);
//     } catch (error) {}
//     setShowSkelton(false);
//   };
//   const staticsArr = [
//     {
//       title: "Total State",
//       count: statics?.totalCount,
//       bgColor: "#6777EF",
//     },
//     {
//       title: "Active State",
//       count: statics?.activeCount,
//       bgColor: "#63ED7A",
//     },
//     {
//       title: "Inactive State",
//       count: statics?.inactiveCount,
//       bgColor: "#FFA426",
//     },
//   ];
//   useEffect(() => {
//     handleGetStateFunc();
//   }, [payload]);
//   const [isLoading, setIsLoading] = useState(false);
//   const [addFormData, setAddFormData] = useState({
//     name: "",
//     status: "",
//     show: false,
//   });

//   const handleAddStateFunc = async () => {
//     setIsLoading(true);
//     try {
//       const payloadToSend = {
//         name: addFormData.name.trim(),
//         status: addFormData.status === "true",
       
//       };

//       const response = await addStateServ(payloadToSend);

//       if (response?.data?.statusCode == "200") {
//         toast.success(response?.data?.message);
//         setAddFormData({
//           name: "",
//           status: "",
//           show: false,
//         });
//         handleGetStateFunc();
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message || "Internal Server Error");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleDeleteStateFunc = async (id) => {
//     const confirmed = window.confirm(
//       "Are you sure you want to delete this State?"
//     );
//     if (confirmed) {
//       try {
//         let response = await deleteStateServ(id);
//         if (response?.data?.statusCode == "200") {
//           toast?.success(response?.data?.message);
//           handleGetStateFunc();
//         }
//       } catch (error) {
//         toast.error(
//           error?.response?.data?.message
//             ? error?.response?.data?.message
//             : "Internal Server Error"
//         );
//       }
//     }
//   };
//   const [editFormData, setEditFormData] = useState({
//     _id: "",
//     name: "",
//     status: "",
//   });

//   const handleUpdateStateFunc = async () => {
//     setIsLoading(true);
//     try {
//       const payloadToSend = {
//         _id: editFormData._id,
//         name: editFormData.name.trim(),
//         status: editFormData.status === "true",
//         deliveryOptionAvailable: editFormData.deliveryOptionAvailable?.length
//           ? editFormData.deliveryOptionAvailable
//           : ["lorryPay"],
//       };

//       const response = await updateStateServ(payloadToSend);
//       if (response?.data?.statusCode == "200") {
//         toast.success(response?.data?.message);
//         setEditFormData({
//           _id: "",
//           name: "",
//           status: "",
//           deliveryOptionAvailable: [],
//         });
//         handleGetStateFunc();
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message || "Internal Server Error");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const [totalPages, setTotalPages] = useState(1);

//   useEffect(() => {
//     if (statics?.totalCount && payload.pageCount) {
//       const pages = Math.ceil(statics.totalCount / payload.pageCount);
//       setTotalPages(pages);
//     }
//   }, [statics, payload.pageCount]);

//   const handlePageChange = (newPage) => {
//     if (newPage >= 1 && newPage <= totalPages) {
//       setPayload({ ...payload, pageNo: newPage });
//     }
//   };

//   const [selectedStates, setSelectedStates] = useState([]);

//   return (
//     <div className="bodyContainer">
//       <Sidebar selectedMenu="Location Management" selectedItem="States" />
//       <div className="mainContainer">
//         <TopNav />
//         <div className="p-lg-4 p-md-3 p-2">
//           <div
//             className="row mx-0 p-0"
//             style={{
//               position: "relative",
//               top: "-75px",
//               marginBottom: "-75px",
//             }}
//           >
//             {staticsArr?.map((v, i) => {
//               return (
//                 <div className="col-md-4 col-12 ">
//                   <div className="topCard shadow-sm py-4 px-3 rounded mb-3">
//                     <div className="d-flex align-items-center ">
//                       <div
//                         className="p-2 shadow rounded"
//                         style={{ background: v?.bgColor }}
//                       >
//                         <img src="https://cdn-icons-png.flaticon.com/128/666/666120.png" />
//                       </div>
//                       <div className="ms-3">
//                         <h6>{v?.title}</h6>
//                         <h2 className="text-secondary">{v?.count}</h2>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//           <div className="row m-0 p-0 d-flex align-items-center my-4 topActionForm">
//             <div className="col-lg-2 mb-2 col-md-12 col-12">
//               <h3 className="mb-0 text-bold text-secondary">States</h3>
//             </div>
//             <div className="col-lg-4 mb-2 col-md-12 col-12">
//               <div>
//                 <input
//                   className="form-control borderRadius24"
//                   placeholder="Search"
//                   onChange={(e) =>
//                     setPayload({
//                       ...payload,
//                       searchKey: e.target.value,
//                       pageNo: 1,
//                     })
//                   }
//                 />
//               </div>
//             </div>
//             <div className="col-lg-3 mb-2  col-md-6 col-12">
//               <div>
//                 <select
//                   className="form-control borderRadius24"
//                   onChange={(e) =>
//                     setPayload({ ...payload, status: e.target.value })
//                   }
//                 >
//                   <option value="">Select Status</option>
//                   <option value={true}>Active</option>
//                   <option value={false}>Inactive</option>
//                 </select>
//               </div>
//             </div>
//             <div className="col-lg-3 mb-2 col-md-6 col-12">
//               <div>
//                 <button
//                   className="btn btn-primary w-100 borderRadius24"
//                   style={{ background: "#6777EF" }}
//                   onClick={() => setAddFormData({ ...addFormData, show: true })}
//                 >
//                   Add State
//                 </button>
//               </div>
//             </div>
//             <div className="col-lg-3 mb-2 col-md-6 col-12">
//               <button
//                 className="btn btn-danger borderRadius24 text-light p-2 mx-2"
//                 disabled={selectedStates.length === 0}
//                 onClick={async () => {
//                   if (
//                     window.confirm(`Delete ${selectedStates.length} states?`)
//                   ) {
//                     try {
//                       const res = await bulkDeleteStateServ(selectedStates);
//                       toast.success(res.data.message);
//                       setSelectedStates([]);
//                       handleGetStateFunc();
//                     } catch (err) {
//                       toast.error("Bulk delete failed");
//                     }
//                   }
//                 }}
//               >
//                 Delete Selected
//               </button>
//             </div>
//           </div>
//           <div className="mt-3">
//             <div className="card-body px-2">
//               <div className="table-responsive table-invoice">
//                 <table className="table">
//                   <tbody>
//                     <tr style={{ background: "#F3F3F3", color: "#000" }}>
//                       <th
//                         className="text-center py-3"
//                         style={{ borderRadius: "30px 0px 0px 30px" }}
//                       >
//                         <label
//                           style={{ cursor: "pointer", userSelect: "none" }}
//                         >
//                           <input
//                             type="checkbox"
//                             style={{ marginRight: "5px" }}
//                             checked={
//                               list.length > 0 &&
//                               selectedStates.length === list.length
//                             }
//                             onChange={(e) => {
//                               if (e.target.checked) {
//                                 setSelectedStates(list.map((s) => s._id)); // select all
//                               } else {
//                                 setSelectedStates([]); // unselect all
//                               }
//                             }}
//                           />
//                           Select All
//                         </label>
//                       </th>

//                       <th className="text-center py-3">Id</th>
//                       <th className="text-center py-3">State Name</th>
//                       <th className="text-center py-3">Status</th>
//                       <th className="text-center py-3">Created At</th>
//                       <th
//                         className="text-center py-3"
//                         style={{ borderRadius: "0px 30px 30px 0px" }}
//                       >
//                         Action
//                       </th>
//                     </tr>

//                     {showSkelton
//                       ? [1, 2, 3, 4, 5].map((v, i) => (
//                           <tr key={i}>
//                             <td className="text-center">
//                               <Skeleton width={50} height={50} />
//                             </td>
//                             <td className="text-center">
//                               <Skeleton width={50} height={50} />
//                             </td>
//                             <td className="text-center">
//                               <Skeleton width={100} height={25} />
//                             </td>
//                             <td className="text-center">
//                               <Skeleton width={100} height={25} />
//                             </td>
//                             <td className="text-center">
//                               <Skeleton width={100} height={25} />
//                             </td>
//                           </tr>
//                         ))
//                       : list?.map((v, i) => (
//                           <tr key={v._id}>
//                             <td className="text-center">
//                               <label
//                                 style={{
//                                   cursor: "pointer",
//                                   userSelect: "none",
//                                 }}
//                               >
//                                 <input
//                                   type="checkbox"
//                                   style={{ marginRight: "5px" }}
//                                   checked={selectedStates.includes(v._id)}
//                                   onChange={(e) => {
//                                     if (e.target.checked) {
//                                       setSelectedStates([
//                                         ...selectedStates,
//                                         v._id,
//                                       ]);
//                                     } else {
//                                       setSelectedStates(
//                                         selectedStates.filter(
//                                           (id) => id !== v._id
//                                         )
//                                       );
//                                     }
//                                   }}
//                                 />
//                                 Select
//                               </label>
//                             </td>

//                             <td className="text-center">{v?.stateId}</td>
//                             <td className="font-weight-600 text-center">
//                               {v?.name}
//                             </td>

//                             <td className="text-center">
//                               {v?.status ? (
//                                 <div
//                                   className="badge py-2"
//                                   style={{ background: "#63ED7A" }}
//                                 >
//                                   Active
//                                 </div>
//                               ) : (
//                                 <div
//                                   className="badge py-2"
//                                   style={{ background: "#FFA426" }}
//                                 >
//                                   Inactive
//                                 </div>
//                               )}
//                             </td>
//                             <td className="text-center">
//                               {moment(v?.createdAt).format("DD-MM-YY")}
//                             </td>
//                             <td className="text-center">
//                               <a
//                                 onClick={() =>
//                                   setEditFormData({
//                                     name: v?.name,
//                                     status: String(v?.status),
//                                     _id: v?._id,
//                                     deliveryOptionAvailable:
//                                       v?.deliveryOptionAvailable || [],
//                                   })
//                                 }
//                                 className="btn btn-info mx-2 text-light shadow-sm"
//                               >
//                                 Edit
//                               </a>
//                               <a
//                                 onClick={() => handleDeleteStateFunc(v?._id)}
//                                 className="btn btn-warning mx-2 text-light shadow-sm"
//                               >
//                                 Delete
//                               </a>
//                             </td>
//                           </tr>
//                         ))}
//                   </tbody>
//                 </table>

//                 <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-5 px-3 py-3 mt-4">
//                   <div className="d-flex align-items-center gap-2">
//                     <span className="fw-semibold text-secondary">Show</span>
//                     <select
//                       className="form-select form-select-sm custom-select"
//                       value={payload.pageCount}
//                       onChange={(e) =>
//                         setPayload({
//                           ...payload,
//                           pageCount: parseInt(e.target.value),
//                           pageNo: 1,
//                         })
//                       }
//                     >
//                       {[10, 25, 50, 100].map((v) => (
//                         <option key={v} value={v}>
//                           {v}
//                         </option>
//                       ))}
//                     </select>
//                   </div>

//                   <nav>
//                     <ul className="pagination pagination-sm mb-0 custom-pagination">
//                       <li
//                         className={`page-item ${
//                           payload.pageNo === 1 ? "disabled" : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(payload.pageNo - 1)}
//                         >
//                           &lt;
//                         </button>
//                       </li>

//                       {[...Array(totalPages)].map((_, i) => {
//                         const page = i + 1;
//                         if (
//                           page === 1 ||
//                           page === totalPages ||
//                           (page >= payload.pageNo - 1 &&
//                             page <= payload.pageNo + 1)
//                         ) {
//                           return (
//                             <li
//                               key={page}
//                               className={`page-item ${
//                                 payload.pageNo === page ? "active" : ""
//                               }`}
//                             >
//                               <button
//                                 className="page-link"
//                                 onClick={() => handlePageChange(page)}
//                               >
//                                 {page}
//                               </button>
//                             </li>
//                           );
//                         } else if (
//                           (page === payload.pageNo - 2 && page > 2) ||
//                           (page === payload.pageNo + 2 && page < totalPages - 1)
//                         ) {
//                           return (
//                             <li key={page} className="page-item disabled">
//                               <span className="page-link">...</span>
//                             </li>
//                           );
//                         }
//                         return null;
//                       })}

//                       <li
//                         className={`page-item ${
//                           payload.pageNo === totalPages ? "disabled" : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(payload.pageNo + 1)}
//                         >
//                           &gt;
//                         </button>
//                       </li>
//                     </ul>
//                   </nav>
//                 </div>

//                 {list.length == 0 && !showSkelton && <NoRecordFound />}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       {addFormData?.show && (
//         <div
//           className="modal fade show d-flex align-items-center  justify-content-center "
//           tabIndex="-1"
//         >
//           <div className="modal-dialog">
//             <div
//               className="modal-content"
//               style={{
//                 borderRadius: "16px",
//                 background: "#f7f7f5",
//                 width: "364px",
//               }}
//             >
//               <div className="d-flex justify-content-end pt-4 pb-0 px-4">
//                 <img
//                   src="https://cdn-icons-png.flaticon.com/128/9068/9068699.png"
//                   style={{ height: "20px" }}
//                   onClick={() =>
//                     setAddFormData({
//                       name: "",
//                       status: "",
//                       show: false,
//                     })
//                   }
//                 />
//               </div>

//               <div className="modal-body">
//                 <div
//                   style={{
//                     wordWrap: "break-word",
//                     whiteSpace: "pre-wrap",
//                   }}
//                   className="d-flex justify-content-center w-100"
//                 >
//                   <div className="w-100 px-2">
//                     <h5 className="mb-4">Add State</h5>

//                     <label className="mt-3">State Name</label>
//                     <input
//                       className="form-control"
//                       type="text"
//                       value={addFormData.name}
//                       onChange={(e) =>
//                         setAddFormData({ ...addFormData, name: e.target.value })
//                       }
//                     />

//                     <label className="mt-3">Status</label>
//                     <select
//                       className="form-control"
//                       value={addFormData.status}
//                       onChange={(e) =>
//                         setAddFormData({
//                           ...addFormData,
//                           status: e.target.value,
//                         })
//                       }
//                     >
//                       <option value="">Select Status</option>
//                       <option value={true}>Active</option>
//                       <option value={false}>Inactive</option>
//                     </select>

//                     <button
//                       className="btn btn-success w-100 mt-4"
//                       onClick={
//                         addFormData?.name && addFormData?.status && !isLoading
//                           ? handleAddStateFunc
//                           : undefined
//                       }
//                       disabled={
//                         !addFormData?.name || !addFormData?.status === "" || isLoading
//                       }
//                       style={{
//                         opacity:
//                           !addFormData?.name ||
//                           !addFormData?.status === "" ||
//                           isLoading
//                             ? "0.5"
//                             : "1",
//                       }}
//                     >
//                       {isLoading ? "Saving..." : "Submit"}
//                     </button>
//                   </div>
//                 </div>
//                 <div className="d-flex justify-content-center"></div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       {addFormData?.show && <div className="modal-backdrop fade show"></div>}
//       {editFormData?._id && (
//         <div
//           className="modal fade show d-flex align-items-center  justify-content-center "
//           tabIndex="-1"
//         >
//           <div className="modal-dialog">
//             <div
//               className="modal-content"
//               style={{
//                 borderRadius: "16px",
//                 background: "#f7f7f5",
//                 width: "364px",
//               }}
//             >
//               <div className="d-flex justify-content-end pt-4 pb-0 px-4">
//                 <img
//                   src="https://cdn-icons-png.flaticon.com/128/9068/9068699.png"
//                   style={{ height: "20px" }}
//                   onClick={() =>
//                     setEditFormData({
//                       name: "",
//                       status: "",
//                       _id: "",
//                     })
//                   }
//                 />
//               </div>

//               <div className="modal-body">
//                 <div
//                   style={{
//                     wordWrap: "break-word",
//                     whiteSpace: "pre-wrap",
//                   }}
//                   className="d-flex justify-content-center w-100"
//                 >
//                   <div className="w-100 px-2">
//                     <h5 className="mb-4">Update State</h5>

//                     <label className="mt-3">State Name</label>
//                     <input
//                       className="form-control"
//                       type="text"
//                       onChange={(e) =>
//                         setEditFormData({
//                           ...editFormData,
//                           name: e.target.value,
//                         })
//                       }
//                       value={editFormData?.name}
//                     />

//                     <label className="mt-3">Status</label>
//                     <select
//                       className="form-control"
//                       onChange={(e) =>
//                         setEditFormData({
//                           ...editFormData,
//                           status: e.target.value,
//                         })
//                       }
//                       value={editFormData?.status}
//                     >
//                       <option value="">Select Status</option>
//                       <option value={true}>Active</option>
//                       <option value={false}>Inactive</option>
//                     </select>

//                     {editFormData?.name && editFormData?.status ? (
//                       <button
//                         className="btn btn-success w-100 mt-4"
//                         onClick={!isLoading && handleUpdateStateFunc}
//                       >
//                         {isLoading ? "Saving..." : "Submit"}
//                       </button>
//                     ) : (
//                       <button
//                         className="btn btn-success w-100 mt-4"
//                         style={{ opacity: "0.5" }}
//                       >
//                         Submit
//                       </button>
//                     )}
//                   </div>
//                 </div>
//                 <div className="d-flex justify-content-center"></div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//       {editFormData?._id && <div className="modal-backdrop fade show"></div>}
//     </div>
//   );
// }

// export default StateList;


import React, { useState, useEffect } from "react";
import Sidebar from "../../Components/Sidebar";
import TopNav from "../../Components/TopNav";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import NoRecordFound from "../../Components/NoRecordFound";

import {
  addStateServ,
  bulkDeleteStateServ,
  deleteStateServ,
  getStateServ,
  updateStateServ,
} from "../../services/location.services";



const STAT_ICONS = ["🌍", "✅", "⏸️"];

function StateList() {
  const [list, setList] = useState([]);
  const [statics, setStatics] = useState(null);

  const [payload, setPayload] = useState({
    searchKey: "",
    status: "",
    pageNo: 1,
    pageCount: 10,
    sortByField: "",
  });

  const [showSkelton, setShowSkelton] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedStates, setSelectedStates] = useState([]);
  const [totalPages, setTotalPages] = useState(1);

  const [addFormData, setAddFormData] = useState({
    name: "",
    status: "",
    show: false,
  });

  const [editFormData, setEditFormData] = useState({
    _id: "",
    name: "",
    status: "",
  });

  const handleGetStateFunc = async () => {
    if (list.length === 0) {
      setShowSkelton(true);
    }

    try {
      const response = await getStateServ(payload);
      setList(response?.data?.data || []);
      setStatics(response?.data?.documentCount);
    } catch (error) {}

    setShowSkelton(false);
  };

  useEffect(() => {
    handleGetStateFunc();
  }, [payload]);

  useEffect(() => {
    if (statics?.totalCount && payload.pageCount) {
      setTotalPages(
        Math.ceil(statics.totalCount / payload.pageCount)
      );
    }
  }, [statics, payload.pageCount]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPayload({ ...payload, pageNo: newPage });
    }
  };

  const handleAddStateFunc = async () => {
    setIsLoading(true);

    try {
      const payloadToSend = {
        name: addFormData.name.trim(),
        status: addFormData.status === "true",
      };

      const response = await addStateServ(payloadToSend);

      if (response?.data?.statusCode == "200") {
        toast.success(response?.data?.message);

        setAddFormData({
          name: "",
          status: "",
          show: false,
        });

        handleGetStateFunc();
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Internal Server Error"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleUpdateStateFunc = async () => {
    setIsLoading(true);

    try {
      const payloadToSend = {
        _id: editFormData._id,
        name: editFormData.name.trim(),
        status: editFormData.status === "true",
      };

      const response = await updateStateServ(payloadToSend);

      if (response?.data?.statusCode == "200") {
        toast.success(response?.data?.message);

        setEditFormData({
          _id: "",
          name: "",
          status: "",
        });

        handleGetStateFunc();
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Internal Server Error"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteStateFunc = async (id) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this state?"
    );

    if (confirmed) {
      try {
        const response = await deleteStateServ(id);

        if (response?.data?.statusCode == "200") {
          toast.success(response?.data?.message);
          handleGetStateFunc();
        }
      } catch (error) {
        toast.error(
          error?.response?.data?.message ||
            "Internal Server Error"
        );
      }
    }
  };

  const staticsArr = [
    {
      title: "Total States",
      count: statics?.totalCount,
      icon: STAT_ICONS[0],
    },
    {
      title: "Active States",
      count: statics?.activeCount,
      icon: STAT_ICONS[1],
    },
    {
      title: "Inactive States",
      count: statics?.inactiveCount,
      icon: STAT_ICONS[2],
    },
  ];

  return (
    <div className="bodyContainer">
      <Sidebar
        selectedMenu="Location Management"
        selectedItem="States"
      />

      <div className="mainContainer">
        <TopNav
          pageTitle="States"
          pagePath="Home / Location Management / States"
        />

        <div className="pl-root">

          {/* ───────── Stats ───────── */}
          <div className="pl-stat-grid">
            {staticsArr.map((v, i) => (
              <div className="pl-stat-card" key={i}>
                <div className="pl-stat-icon">{v.icon}</div>

                <div>
                  <div className="pl-stat-val">
                    {v.count ?? "—"}
                  </div>

                  <div className="pl-stat-lbl">
                    {v.title}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* ───────── Toolbar ───────── */}
          <div className="pl-toolbar">

            <div className="pl-toolbar-title">
              States
            </div>

            <input
              className="pl-input"
              placeholder="🔍 Search states..."
              onChange={(e) =>
                setPayload({
                  ...payload,
                  searchKey: e.target.value,
                  pageNo: 1,
                })
              }
            />

            <select
              className="pl-select"
              onChange={(e) =>
                setPayload({
                  ...payload,
                  status: e.target.value,
                })
              }
            >
              <option value="">All Status</option>
              <option value={true}>Active</option>
              <option value={false}>Inactive</option>
            </select>

            <button
              className="pl-btn pl-btn-red"
              onClick={() =>
                setAddFormData({
                  ...addFormData,
                  show: true,
                })
              }
            >
              <i className="ti ti-plus" />
              Add State
            </button>

            <button
              className="pl-btn pl-btn-danger"
              disabled={selectedStates.length === 0}
              onClick={async () => {
                if (
                  window.confirm(
                    `Delete ${selectedStates.length} state(s)?`
                  )
                ) {
                  try {
                    const res =
                      await bulkDeleteStateServ(
                        selectedStates
                      );

                    toast.success(res.data.message);

                    setSelectedStates([]);

                    handleGetStateFunc();
                  } catch (err) {
                    toast.error("Bulk delete failed");
                  }
                }
              }}
            >
              <i className="ti ti-trash" />
              Delete{" "}
              {selectedStates.length > 0
                ? `(${selectedStates.length})`
                : "Selected"}
            </button>
          </div>

          {/* ───────── Table ───────── */}
          <div className="pl-table-wrap">

            <div className="pl-table-scroll">

              <table className="pl-table">

                <thead>
                  <tr>
                    <th>
                      <label className="pl-check-label">
                        <input
                          type="checkbox"
                          className="pl-check"
                          checked={
                            list.length > 0 &&
                            selectedStates.length ===
                              list.length
                          }
                          onChange={(e) =>
                            setSelectedStates(
                              e.target.checked
                                ? list.map((s) => s._id)
                                : []
                            )
                          }
                        />
                        All
                      </label>
                    </th>

                    {/* <th>#</th> */}
                    <th>State ID</th>
                    <th>State Name</th>
                    <th className="center">
                      Status
                    </th>
                    <th className="center">
                      Created At
                    </th>
                    <th className="center">
                      Action
                    </th>
                  </tr>
                </thead>

                <tbody>

                  {showSkelton ? (
                    [...Array(10)].map((_, i) => (
                      <tr key={i}>
                        {[...Array(7)].map((__, j) => (
                          <td
                            key={j}
                            className="pl-skel-cell"
                          >
                            <Skeleton height={20} />
                          </td>
                        ))}
                      </tr>
                    ))
                  ) : list?.length === 0 ? (
                    <tr>
                      <td
                        colSpan="7"
                        style={{
                          textAlign: "center",
                          padding: "50px",
                        }}
                      >
                        <NoRecordFound />
                      </td>
                    </tr>
                  ) : (
                    list?.map((v, i) => (
                      <tr key={v._id}>

                        {/* checkbox */}
                        <td>
                          <label className="pl-check-label">
                            <input
                              type="checkbox"
                              className="pl-check"
                              checked={selectedStates.includes(
                                v._id
                              )}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedStates([
                                    ...selectedStates,
                                    v._id,
                                  ]);
                                } else {
                                  setSelectedStates(
                                    selectedStates.filter(
                                      (id) =>
                                        id !== v._id
                                    )
                                  );
                                }
                              }}
                            />
                          </label>
                        </td>

                        {/* sr no */}
                        {/* <td>
                          <span className="pl-sr">
                            {(payload.pageNo - 1) *
                              payload.pageCount +
                              i +
                              1}
                          </span>
                        </td> */}

                        {/* state id */}
                        <td>
                          <span className="pl-sr">
                            {v?.stateId}
                          </span>
                        </td>

                        {/* name */}
                        <td>
                          <div className="pl-prod-name">
                            {v?.name}
                          </div>
                        </td>

                        {/* status */}
                        <td className="center">
                          {v?.status ? (
                            <span className="pl-badge active">
                              <i
                                className="ti ti-circle-check"
                                style={{
                                  fontSize: 13,
                                }}
                              />
                              Active
                            </span>
                          ) : (
                            <span className="pl-badge inactive">
                              <i
                                className="ti ti-circle-x"
                                style={{
                                  fontSize: 13,
                                }}
                              />
                              Inactive
                            </span>
                          )}
                        </td>

                        {/* created at */}
                        <td className="center">
                          {moment(
                            v?.createdAt
                          ).format("DD MMM YYYY")}
                        </td>

                        {/* actions */}
                        <td className="center">

                          <button
                            className="pl-view-btn"
                            style={{ marginRight: 8 }}
                            onClick={() =>
                              setEditFormData({
                                name: v?.name,
                                status: String(
                                  v?.status
                                ),
                                _id: v?._id,
                              })
                            }
                          >
                            <i className="ti ti-edit" />
                            Edit
                          </button>

                          <button
                            className="pl-view-btn"
                            onClick={() =>
                              handleDeleteStateFunc(
                                v?._id
                              )
                            }
                          >
                            <i className="ti ti-trash" />
                            Delete
                          </button>

                        </td>
                      </tr>
                    ))
                  )}

                </tbody>
              </table>
            </div>

            {/* ───────── Pagination ───────── */}
            <div className="pl-pagination">

              <div className="pl-show-row">
                Show

                <select
                  className="pl-select"
                  style={{
                    height: "34px",
                    padding: "0 10px",
                    minWidth: "unset",
                  }}
                  value={payload.pageCount}
                  onChange={(e) =>
                    setPayload({
                      ...payload,
                      pageCount: parseInt(
                        e.target.value
                      ),
                      pageNo: 1,
                    })
                  }
                >
                  {[10, 25, 50, 100].map((v) => (
                    <option key={v} value={v}>
                      {v}
                    </option>
                  ))}
                </select>

                entries
              </div>

              <div className="pl-page-btns">

                <button
                  className="pl-pg-btn"
                  disabled={payload.pageNo === 1}
                  onClick={() =>
                    handlePageChange(
                      payload.pageNo - 1
                    )
                  }
                >
                  <i className="ti ti-chevron-left" />
                </button>

                {[...Array(totalPages)].map((_, i) => {
                  const page = i + 1;

                  if (
                    page === 1 ||
                    page === totalPages ||
                    (page >= payload.pageNo - 1 &&
                      page <= payload.pageNo + 1)
                  ) {
                    return (
                      <button
                        key={page}
                        className={`pl-pg-btn ${
                          payload.pageNo === page
                            ? "active"
                            : ""
                        }`}
                        onClick={() =>
                          handlePageChange(page)
                        }
                      >
                        {page}
                      </button>
                    );
                  } else if (
                    (page ===
                      payload.pageNo - 2 &&
                      page > 2) ||
                    (page ===
                      payload.pageNo + 2 &&
                      page < totalPages - 1)
                  ) {
                    return (
                      <button
                        key={page}
                        className="pl-pg-btn"
                        disabled
                      >
                        …
                      </button>
                    );
                  }

                  return null;
                })}

                <button
                  className="pl-pg-btn"
                  disabled={
                    payload.pageNo === totalPages
                  }
                  onClick={() =>
                    handlePageChange(
                      payload.pageNo + 1
                    )
                  }
                >
                  <i className="ti ti-chevron-right" />
                </button>

              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ───────── Add Modal ───────── */}
      {addFormData?.show && (
        <div
          className="pl-modal-overlay"
          onClick={() =>
            setAddFormData({
              name: "",
              status: "",
              show: false,
            })
          }
        >
          <div
            className="pl-modal"
            onClick={(e) => e.stopPropagation()}
          >

            <div className="pl-modal-header">
              <div className="pl-modal-title">
                Add State
              </div>

              <button
                className="pl-modal-close"
                onClick={() =>
                  setAddFormData({
                    name: "",
                    status: "",
                    show: false,
                  })
                }
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <div className="pl-modal-body">

              <label className="pl-field-label">
                State Name
              </label>

              <input
                className="pl-field-input"
                type="text"
                placeholder="Enter state name"
                value={addFormData.name}
                onChange={(e) =>
                  setAddFormData({
                    ...addFormData,
                    name: e.target.value,
                  })
                }
              />

              <label className="pl-field-label">
                Status
              </label>

              <select
                className="pl-field-input"
                value={addFormData.status}
                onChange={(e) =>
                  setAddFormData({
                    ...addFormData,
                    status: e.target.value,
                  })
                }
              >
                <option value="">
                  Select Status
                </option>

                <option value={true}>
                  Active
                </option>

                <option value={false}>
                  Inactive
                </option>
              </select>

            </div>

            <div className="pl-modal-footer">

              <button
                className="pl-btn"
                style={{
                  background: "#f0eded",
                  color: "#555",
                }}
                onClick={() =>
                  setAddFormData({
                    name: "",
                    status: "",
                    show: false,
                  })
                }
              >
                Cancel
              </button>

              <button
                className="pl-btn pl-btn-red"
                disabled={
                  !addFormData?.name ||
                  !addFormData?.status ||
                  isLoading
                }
                onClick={
                  !isLoading
                    ? handleAddStateFunc
                    : undefined
                }
              >
                {isLoading
                  ? "Saving..."
                  : "Add State"}
              </button>

            </div>
          </div>
        </div>
      )}

      {/* ───────── Edit Modal ───────── */}
      {editFormData?._id && (
        <div
          className="pl-modal-overlay"
          onClick={() =>
            setEditFormData({
              _id: "",
              name: "",
              status: "",
            })
          }
        >
          <div
            className="pl-modal"
            onClick={(e) => e.stopPropagation()}
          >

            <div className="pl-modal-header">

              <div className="pl-modal-title">
                Update State
              </div>

              <button
                className="pl-modal-close"
                onClick={() =>
                  setEditFormData({
                    _id: "",
                    name: "",
                    status: "",
                  })
                }
              >
                <i className="ti ti-x" />
              </button>

            </div>

            <div className="pl-modal-body">

              <label className="pl-field-label">
                State Name
              </label>

              <input
                className="pl-field-input"
                type="text"
                value={editFormData?.name}
                onChange={(e) =>
                  setEditFormData({
                    ...editFormData,
                    name: e.target.value,
                  })
                }
              />

              <label className="pl-field-label">
                Status
              </label>

              <select
                className="pl-field-input"
                value={editFormData?.status}
                onChange={(e) =>
                  setEditFormData({
                    ...editFormData,
                    status: e.target.value,
                  })
                }
              >
                <option value="">
                  Select Status
                </option>

                <option value={true}>
                  Active
                </option>

                <option value={false}>
                  Inactive
                </option>
              </select>

            </div>

            <div className="pl-modal-footer">

              <button
                className="pl-btn"
                style={{
                  background: "#f0eded",
                  color: "#555",
                }}
                onClick={() =>
                  setEditFormData({
                    _id: "",
                    name: "",
                    status: "",
                  })
                }
              >
                Cancel
              </button>

              <button
                className="pl-btn pl-btn-red"
                disabled={
                  !editFormData?.name ||
                  !editFormData?.status ||
                  isLoading
                }
                onClick={
                  !isLoading
                    ? handleUpdateStateFunc
                    : undefined
                }
              >
                {isLoading
                  ? "Saving..."
                  : "Update State"}
              </button>

            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default StateList;